export default "__VITE_ASSET__CrUOYj1$__"